// src/hooks/useBrowserEvents.ts
import { useEffect } from 'react';
import { AuthUtils } from '../utils/authUtils';

export const useBrowserEvents = (enabled: boolean = true) => {
  useEffect(() => {
    if (!enabled) return;

    // Sayfa yenileme öncesi temizlik
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      // Session'ı localStorage'a kaydet (sayfa yenileme için)
      localStorage.setItem('lastActivity', Date.now().toString());
    };

    // Sayfa gizlendiğinde (sekme değiştirme)
    const handleVisibilityChange = () => {
      if (document.hidden) {
        localStorage.setItem('lastActivity', Date.now().toString());
      } else {
        // Sayfa tekrar görünür olduğunda session kontrol et
        setTimeout(async () => {
          const isValid = await AuthUtils.validateSession();
          if (!isValid) {
            console.log('🔄 Session geçersiz, temizleniyor...');
            await AuthUtils.clearAllAuthData();
          }
        }, 1000);
      }
    };

    // Sekme kapatma (tam kapanma)
    const handlePageHide = () => {
      // Sadece son aktiviteyi kaydet, session'ı korumaya çalış
      localStorage.setItem('lastActivity', Date.now().toString());
    };

    // Event listener'ları ekle
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('pagehide', handlePageHide);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('pagehide', handlePageHide);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [enabled]);
};
